import React, { Component } from 'react';
import {Button} from 'semantic-ui-react';

class RefreshButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
        this.onClick = this.onClick.bind(this);
    }
    async onClick(e) {
        const {action} = this.props;
        this.setState({loading: true});
        await action(e);
        this.setState({loading: false});
    }
    render() {
        const {loading} = this.state;
        return (
            <Button icon="refresh" {...{...this.props, loading}} onClick={this.onClick}  />
        );
    }
}

RefreshButton.propTypes = {

};

export default RefreshButton;